<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :loading="loading"
    loading-text="Buscando..."
    no-data-text="No hay resultados"
    :footer-props="{
      'items-per-page-text':'Elementos por página',
      pageText: '{0}-{1} de {2}' }"
  >
    <template v-slot:top>
      <v-row no-gutters>
        <v-col cols="12" :md="endpointSucursales ? 8 : 12" class="pa-3">
          <v-text-field
            filled
            rounded
            v-model="search"
            prepend-inner-icon="search"
            label="Buscar"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col v-if="endpointSucursales" cols="12" md="4" class="pa-3">
          <Select label="Tipo" v-model="tipo" :items="tipos" item-value="id" item-text="nombre"></Select>
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.nota.promedio="{ item }">
      <div v-if="item.nota" class="d-flex align-center">
        <v-rating
          color="primary"
          background-color="grey darken-1"
          fullIcon="mdi-star"
          half-icon="mdi-star-half-full"
          half-increments
          emptyIcon="mdi-star-outline"
          :value="item.nota.promedio"
          readonly
          dense
          small
        ></v-rating>
        <span class="ml-2 font-italic text-no-wrap">
          {{ Math.round(item.nota.promedio * 10) / 10 }} ({{ item.nota.total }})
        </span>
      </div>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn color="primary" @click="empresa_url(item)">Ver detalles</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Select from '@/components/forms/Select.vue'
import { tablesService } from '@/services'

const EMPRESA = 0
const SUCURSAL = 1

// Milisegundos sin teclear antes de buscar.
const ESPERA_BUSQUEDA = 300

// La tabla de empresas, con su buscador. La búsqueda la hace el backend
// (api.utils.queries.get_search_results) en el endpoint que se le pase. Con
// `endpointSucursales` agrega el selector de tipo para listar sucursales.
export default {
  components: { Select },
  props: {
    endpointEmpresas: { type: String, required: true },
    endpointSucursales: { type: String, default: null },
    // Ruta de la ficha de una empresa, a la que se le agrega el id.
    rutaDetalle: { type: String, default: "/empresas/" },
  },
  data: () => ({

    tipos: [{id: EMPRESA, nombre: 'Empresa'}, {id: SUCURSAL, nombre: 'Sucursal'}],
    tipo: EMPRESA,
    search: "",
    items: [],
    loading: false,
    espera: null,
    // Número de la última búsqueda pedida: una respuesta anterior que llega
    // tarde no pisa a la más nueva.
    pedido: 0,

  }),
  watch:{
    tipo(){
      this.items = [];
      this.buscar();
    },
    search(){
      clearTimeout(this.espera);
      this.espera = setTimeout(this.buscar, ESPERA_BUSQUEDA);
    }
  },
  computed: {
    headers(){
      if (this.tipo === SUCURSAL) {
        return [
          { text: "Empresa", align: "left", sortable: true, value: "empresa.nombre" },
          { text: "Dirección", align: "left", sortable: true, value: "direccion" },
          { text: "Región", align: "left", sortable: true, value: "region.name" },
          { text: "País", align: "left", sortable: true, value: "pais.name" },
          { text: "Acciones", value: "action", sortable: false, width: "8%" }
        ]
      }
      return [
        { text: "Empresa", align: "left", sortable: true, value: "nombre" },
        { text: "RUT", align: "left", sortable: true, value: "rut" },
        { text: "Puntuación", align: "left", sortable: true, value: "nota.promedio" },
        { text: "Sucursales", align: "left", sortable: true, value: "n_sucursales" },
        { text: "Acciones", value: "action", sortable: false, width: "8%" }
      ]
    },
  },
  created() {
    this.buscar();
  },
  beforeDestroy() {
    clearTimeout(this.espera);
  },
  methods: {
    buscar() {
      clearTimeout(this.espera);
      const pedido = ++this.pedido;
      const endpoint = this.tipo === SUCURSAL ? this.endpointSucursales : this.endpointEmpresas;
      this.loading = true;

      tablesService
        .getService(endpoint, `?q=${encodeURIComponent(this.search || "")}`)
        .then((items) => {
          if (pedido !== this.pedido) {
            return;
          }
          this.items = items;
          this.loading = false;
        })
        .catch(() => {
          if (pedido !== this.pedido) {
            return;
          }
          this.loading = false;
          this.$store.dispatch("alert/error", "No se pudo cargar la lista.");
        });
    },
    empresa_url(item) {
      const id = this.tipo === SUCURSAL ? item.empresa.id : item.id;
      this.$router.push(this.rutaDetalle + id);
    },
  }
};
</script>

<style>
</style>
